import { Fragment, useState } from "react";
import { Modal } from "react-bootstrap";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { logo_title } from "../../assets";
import { Button } from "../../styles";
import { navLink } from "../../utils/data";
import { removeData } from "../../utils/helpers";
import { ICON_LOGOUT } from "../../utils/icons";
import { useThemeContext } from "../../context/theme_context";
import { useAuthContext } from "../../context/auth_context";

const NavLinks = () => {

  const navigate = useNavigate();

  const {
    darkMode: { darkTheme }
  } = useThemeContext();

  const {
    getFeature: { checkFeature }
  } = useAuthContext();

  // Modal
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => { setShow(true); };
  // Modal

  function logout() {
    removeData('businessData');
    removeData('storeData');
    removeData('accountData');
    removeData('featureAccess');
    toast.success('Logout successful! Redirecting...');
    setTimeout(() => {
      navigate("/");
    }, 1500);
  }

  return (
    <>
      <div className="ml-3">
        <Link to="/user/dashboard" className="navbar-brand white-text">
          <img src={darkTheme === 'dark' ? logo_title : logo_title} alt="Reni Finance Logo" width='300px' className="mx-auto" />
        </Link>
      </div>
      <ul className="navbar-nav ml-auto mr-auto mt-3">

        {navLink.map(({ title, to, icon, name }, i) => {
          return (
            checkFeature(name) && <Fragment key={i}>
              <li className="nav-item" >
                <NavLink to={to}>
                  {icon}
                  {title}
                </NavLink>
              </li>
            </Fragment>
          );
        })}
        <li className="nav-item">
          <a className="red-text pointer"
            onClick={() => handleShow()}
          >
            {ICON_LOGOUT}
            Logout
          </a>
        </li>

      </ul>

      <Modal
        show={show}
        onHide={handleClose}
        // backdrop="static"
        keyboard={false}
        centered
        size="lg"
      >
        <Modal.Header>
        </Modal.Header>
        <Modal.Body >
          <div className=" text-center ">
            <div className="red-text br-lg shadow fit-content mx-auto px-3 mb-3" style={{ fontSize: '3rem' }}>
              {ICON_LOGOUT}
            </div>
            <h5 className="my-5">
              Are you sure you want to logout?
            </h5>

            <div className="d-flex gap-2">
              <Button className="btn red-bg light-text w-50"
                onClick={() => logout()}>
                Confirm
              </Button>
              <Button className="btn border border-danger red-text w-50"
                onClick={() => handleClose()}>
                Cancel
              </Button>
            </div>
          </div>
        </Modal.Body>

      </Modal>
    </>
  );
};

export default NavLinks;
